import { useEffect, useState } from 'react';
import Header from '@/components/Header';
import Signup from '@/components/Signup';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/constants/routes';
import LargeContainer from '@/components/front-office/containers/LargeContainer';


const SignupPage = () => {
	const [errors, setErrors] = useState(null);
	const role = JSON.parse(localStorage.getItem('role'));
	const navigate = useNavigate();

	useEffect(() => {
		if (role && !['admin', 'super-admin'].includes(role)) {
			navigate(routes.home);
		}
	}, []);

	return (
		<LargeContainer withImage={false}>
			<Header
				heading="Inscrivez-vous pour créer un compte"
				paragraph="Vous avez déjà un compte ?"
				linkName="Connexion"
				linkUrl="/login"
			/>

			{errors && (
				<ul>
					{Object.entries(errors).map((error, index) => {
						return (
							<li key={index || error} className="text-red-500 text-sm">
								{error[1]}
							</li>
						);
					})}
				</ul>
			)}

			<Signup errors={errors} setErrors={setErrors} />
		</LargeContainer>
	);
};

export default SignupPage;
